import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fantasy-flight-games': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32.9L32.9 256 256 479.1 479.1 256 256 32.9zM88.3 255.8C90.3 253.8 100.3 243.5 184.8 158.4 226.3 116.6 271 114.6 304.6 139.7 329.2 158.1 366.7 198.6 366.8 198.7 367.4 199.4 367.8 201.5 367.3 202 356.1 213.9 344.6 225.6 333.8 236.7 299.6 204.4 293.3 198.5 285.3 192.8 267.6 180.1 243.9 182.6 228.3 197.9 226.2 200 226.6 201.3 228.5 203.2 231.4 206.2 256.6 231.6 263.6 239 251.6 250.6 239.9 262 227.9 273.7 215.8 261.1 203.4 248.1 191.3 235.6 169.9 256.6 149.6 276.7 129.5 296.6A42569-42569 0 0 0 88.3 255.8zM323.2 357.4C287.7 392.9 245.1 395.6 216.2 377.9 194.1 364.4 176.8 345.8 143.2 311.1 155.3 298.7 167 286.6 178.6 274.7 211.6 306.7 215.7 310.8 223.3 316.8 241.8 331.6 265.8 330.5 282.6 315 286.3 311.6 286.3 311.4 282.8 307.8 272.2 297.1 261.6 286.4 251 275.6 249.7 274.3 247.9 273.1 250.2 270.9 261 260.2 271.7 249.4 282.4 238.6 282.6 238.4 283 238.3 284.3 237.6 296.7 250.4 309.2 263.5 321.6 276.3 342.6 255.6 362.8 235.6 382.8 215.9 396.5 229.3 409.9 242.5 423.7 255.9 403.5 276.8 342 338.6 323.2 357.4zM256 0L0 256 256 512 512 256 256 0zM16 256L256 16 496 256 256 496 16 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fantasy-flight-games.js
// module id = EFNa
// module chunks = 144